import {
    ADDRESSES_RECEIVED,
    BILLING_ADDRESS_ADDED,
    BILLING_ADDRESS_SELECTED,
    SHIPPING_ADDRESS_ADDED
} from "../Constants";

export default function(state = {}, action) {
    switch (action.type) {
    case ADDRESSES_RECEIVED:
    case BILLING_ADDRESS_ADDED:
    case BILLING_ADDRESS_SELECTED:
    case SHIPPING_ADDRESS_ADDED:
        return action.payload;
    }
    return state;
}